export default __webpack_public_path__ + "static/media/trr-drink-specialty-rosegoldlatte.e84db3db.png";